module.exports = __webpack_public_path__ + "static/img/6.c748799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/6.png
// module id = ygWY
// module chunks = 0